"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Every cell should be in a `LayoutGridCell`. Behaviour for grids containing direct
 * children without the cell wrapper is undefined.
 */


var LayoutGridCell = function (_Component) {
  _inherits(LayoutGridCell, _Component);

  function LayoutGridCell() {
    _classCallCheck(this, LayoutGridCell);

    return _possibleConstructorReturn(this, (LayoutGridCell.__proto__ || Object.getPrototypeOf(LayoutGridCell)).apply(this, arguments));
  }

  _createClass(LayoutGridCell, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _props = this.props,
          span = _props.span,
          spanDesktop = _props.spanDesktop,
          spanTablet = _props.spanTablet,
          spanPhone = _props.spanPhone,
          order = _props.order,
          align = _props.align,
          className = _props.className,
          children = _props.children,
          other = _objectWithoutProperties(_props, ["span", "spanDesktop", "spanTablet", "spanPhone", "order", "align", "className", "children"]);

      return _react2.default.createElement("div", _extends({
        className: (0, _classnames3.default)("mdc-layout-grid__cell", (_classnames = {}, _defineProperty(_classnames, "mdc-layout-grid__cell--span-" + span, span), _defineProperty(_classnames, "mdc-layout-grid__cell--span-" + spanDesktop + "-desktop", spanDesktop), _defineProperty(_classnames, "mdc-layout-grid__cell--span-" + spanTablet + "-tablet", spanTablet), _defineProperty(_classnames, "mdc-layout-grid__cell--span-" + spanPhone + "-phone", spanPhone), _defineProperty(_classnames, "mdc-layout-grid__cell--order-" + order, order), _defineProperty(_classnames, "mdc-layout-grid__cell--align-" + align, align), _classnames), className)
      }, other), children);
    }
  }]);

  return LayoutGridCell;
}(_react.Component);

LayoutGridCell.propTypes = {
  /** You can set the cells span by applying the span prop which is an integer between 1 and 12. */
  span: _propTypes.number,

  /** Cell span in desktop size */
  spanDesktop: _propTypes.number,

  /** Cell span in tablet size. */
  spanTablet: _propTypes.number,

  /** Cell span in phone size. */
  spanPhone: _propTypes.number,

  /** By default, items are positioned in the source order. However, you can reorder them by using the order prop which is an integer between 1 and 12. */
  order: _propTypes.number,

  /** Items are defined to stretch, by default, taking up the height of their corresponding row. You can switch to a different behaviour by using one of the alignment values. */
  align: (0, _propTypes.oneOf)(["top", "middle", "bottom"])
};
exports.default = LayoutGridCell;